export default __webpack_public_path__ + "static/office-tour-preview-32b22f29957673a561e50fc2597f1b0e.mp4";